module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-f752a20ab28d7c9fd6edb34ae8d4afd1.png";